import { render } from "./TheTreeMenu.vue?vue&type=template&id=f8f0417a"
import script from "./TheTreeMenu.vue?vue&type=script&lang=js"
export * from "./TheTreeMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__